import { fetchApi } from "../fetchApi";

export async function checkApi({ params, endpoint }) {
  const raw = JSON.stringify({
    jsonrpc: "2.0",
    method: "call",
    params,
  });

  const requestOptions = {
    method: "POST",
    body: raw,
    redirect: "follow",
  };
  let response = await fetchApi({
    requestOptions,
    endpoint,
  });
  response = JSON.parse(response);
  return response;
}
